var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "#FFDB43"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_12590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5215 54.0352C14.6677 53.7627 14.7611 53.5759 14.8654 53.3963C16.485 50.6269 18.097 47.8531 19.7381 45.0963C19.9634 44.7181 19.9454 44.491 19.679 44.1432C11.0519 32.8824 17.8214 16.6417 31.9471 14.6987C41.951 13.3227 51.3929 20.2221 52.9079 30.0825C53.7163 35.3357 52.4597 40.1066 49.1698 44.3217C48.8755 44.6987 48.8268 44.9476 49.08 45.3748C50.6504 48.0232 52.1846 50.6925 53.7299 53.3555C53.8365 53.5395 53.9359 53.7274 54.1057 54.0352C53.2993 54.0352 52.58 54.0396 51.8606 54.0352C51.1018 54.0297 50.2035 54.2604 49.6264 53.9347C49.0492 53.6091 48.7852 52.7312 48.405 52.0832C44.3188 45.1201 36.5319 31.8343 32.4436 24.8712C32.2099 24.4756 32.1732 24.1785 32.4096 23.7634C33.0706 22.6062 33.6761 21.4177 34.3799 20.0987L46.5162 40.9331C49.7366 36.7465 50.4671 28.8663 45.1706 23.2143C39.8545 17.5405 31.0928 17.0029 25.1205 21.9878C19.0495 27.0547 18.621 35.3725 22.2847 40.7297L34.3799 20.0987C34.7521 20.7349 35.086 21.2895 35.4048 21.8529C35.8485 22.6331 36.3836 23.4004 36.3884 24.1892C36.3928 24.9516 35.8449 25.7424 35.3984 26.504C30.1201 35.4901 24.844 44.4773 19.57 53.4655C19.3211 53.89 19.0635 54.0661 18.5551 54.0503C17.2414 54.0083 15.9258 54.0352 14.5215 54.0352Z",
    fill: "#1D2624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7734 50.6002L25.7812 47.1831C31.5047 50.9115 37.2482 50.9527 43.0663 47.2959L45.0485 50.6698C39.6446 54.9153 30.1124 55.3956 23.7734 50.6002Z",
    fill: "#1D2624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_12590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.5842,
    height: 39.5842,
    fill: "white",
    transform: "translate(14.5254 14.5239)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogo);
export default __webpack_public_path__ + "static/media/authLogo.ecb625d446c5c93908ef507c094f4f2e.svg";
export { ForwardRef as ReactComponent };